let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2Hg4x")).then(() => parcelRequire('faBdF'));